// Default grids that come with the game
// Format: "1A2,2J8,...9F6" where each entry is digit + column letter (A-J) + row (0-9)
// These grids cannot be deleted by the user

export const DEFAULT_GRIDS: string[] = [
    "6/1-3:1D1,2A2,3E3",
    "8/1-6:1G5,2C4,3H3,4D2,5A5,6D6",
    "10/1-9:1G1,2H4,3I6,4F7,5C9,6B3,7J2,8C6,9D4",
    "6/0-3:0C4,1F2,2A3,3D1",
];

/** A grid is a built-in default iff its data matches the canonical list exactly. */
export function isDefaultGrid(gridData: string): boolean {
    return DEFAULT_GRIDS.includes(gridData);
}
